import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import {
  DocumentsCategoryTypes,
  DocumentsConfidentialityLevels,
  DocumentsTypes,
} from "src/modules/data-protection/constants";

import { EMPTY_DOCUMENT } from "../helpers/documents";

const DocumentsSection = ({ documents, errors, onChange, t }) => {
  const updateDocument = (index, field, value) => {
    onChange(
      documents.map((document, currentIndex) =>
        currentIndex === index ? { ...document, [field]: value } : document
      )
    );
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <Label className="mb-0">{t("Documents")}</Label>
        <Button
          color="secondary"
          size="sm"
          type="button"
          onClick={() => onChange([...documents, { ...EMPTY_DOCUMENT }])}
        >
          {t("Add Document")}
        </Button>
      </div>

      {documents.length === 0 ? (
        <p className="text-muted mb-0">{t("No documents added yet.")}</p>
      ) : (
        documents.map((document, index) => (
          <Row className="align-items-end" key={index}>
            <Col sm="12" md="6" lg="3">
              <FormGroup>
                <Label for={`document-title-${index}`}>{t("Title")}</Label>
                <Input
                  id={`document-title-${index}`}
                  value={document.title}
                  onChange={(event) =>
                    updateDocument(index, "title", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col sm="12" md="6" lg="2">
              <FormGroup>
                <Label for={`document-link-${index}`}>{t("Link")}</Label>
                <Input
                  id={`document-link-${index}`}
                  value={document.link}
                  onChange={(event) =>
                    updateDocument(index, "link", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col sm="12" md="6" lg="2">
              <FormGroup>
                <Label for={`document-type-${index}`}>{t("Type")}</Label>
                <Input
                  id={`document-type-${index}`}
                  type="select"
                  value={document.type}
                  onChange={(event) =>
                    updateDocument(index, "type", event.target.value)
                  }
                >
                  {DocumentsTypes.filter(
                    (documentType) => documentType.creatable
                  ).map((documentType) => (
                    <option key={documentType.value} value={documentType.value}>
                      {t(documentType.title)}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col sm="12" md="6" lg="2">
              <FormGroup>
                <Label for={`document-category-${index}`}>{t("Category")}</Label>
                <Input
                  id={`document-category-${index}`}
                  type="select"
                  value={document.category}
                  onChange={(event) =>
                    updateDocument(index, "category", event.target.value)
                  }
                >
                  <option value="">{t("Select Category")}</option>
                  {DocumentsCategoryTypes.map((categoryType) => (
                    <option key={categoryType.value} value={categoryType.value}>
                      {t(categoryType.title)}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col sm="12" md="6" lg="2">
              <FormGroup>
                <Label for={`document-confidentiality-${index}`}>
                  {t("Confidentiality Level")}
                </Label>
                <Input
                  id={`document-confidentiality-${index}`}
                  type="select"
                  value={document.confidentialityLevel}
                  onChange={(event) =>
                    updateDocument(
                      index,
                      "confidentialityLevel",
                      event.target.value
                    )
                  }
                >
                  <option value="">{t("Select Level")}</option>
                  {DocumentsConfidentialityLevels.map((level) => (
                    <option key={level.value} value={level.value}>
                      {t(level.title)}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col sm="12" md="6" lg="1">
              <FormGroup>
                <Button
                  color="danger"
                  size="sm"
                  type="button"
                  onClick={() =>
                    onChange(
                      documents.filter(
                        (_document, currentIndex) => currentIndex !== index
                      )
                    )
                  }
                >
                  {t("Remove")}
                </Button>
              </FormGroup>
            </Col>
          </Row>
        ))
      )}

      {(errors || []).map((error) => (
        <small className="text-danger d-block" key={error}>
          {error}
        </small>
      ))}
    </>
  );
};

export default DocumentsSection;
